const filterElements=document.querySelectorAll('.filter-wrapper>select');

for(const filterElement of filterElements){
    document.addEventListener('click', (e)=>{
        if(e.target!==filterElement){
            filterElement.blur();
        }
    })
    filterElement.addEventListener('change', ()=>{
        filterElement.blur();
    })

}



const filterListWrapper=document.querySelectorAll('.filter-list-wrapper');


for (const wrapper of filterListWrapper) {
    const filters=wrapper.querySelectorAll('[data-filterprop]');
    if(!filters || !filters.length) continue;

    const items = wrapper.querySelectorAll('.filter-list-item');
    if (!items || !items.length) continue;

    const firstPageCount=12;

    handleLoadMore(wrapper);


    for(const filter of filters){
        filter.addEventListener('change', e=>{
            const filterTarget=filter.dataset.filterprop;
            if(!filterTarget) return;

            const filterValue=e.target.value;

            for(const otherFilter of filters){ // reset all other filters when a filter is selected
                if(otherFilter!==filter){
                    otherFilter.value="";
                }
            }

            const visibleItemsMap={}; // track already displayed items to not display doubles
            const visibleItemsList=[];

            for(const item of items){
                const itemPropValue=item.dataset[filterTarget];
                const itemUid=item.dataset.uid;

                if(!visibleItemsMap[itemUid] && (!itemPropValue || !filterValue || filterValue=="" || itemPropValue==filterValue)){
                    item.classList.remove('hidden-by-filter');
                    visibleItemsList.push(item);

                    if(itemUid){
                        visibleItemsMap[itemUid]=true;
                    }
                    // initially only display 12 items after filtering
                    if(visibleItemsList.length>firstPageCount){
                        item.classList.add('hidden-by-pagination')
                    }else{
                        item.classList.remove('hidden-by-pagination')
                    }
                }else{
                    item.classList.add('hidden-by-filter');
                    item.classList.add('hidden-by-pagination')
                }

            }

            handleLoadMore(wrapper);


        })
    }


}


export function handleLoadMore(paginatedListWrapper){
    const loadMoreButton=paginatedListWrapper.querySelector('.load-more-trigger');
    if(!loadMoreButton) return;
    let hiddenItems=paginatedListWrapper.querySelectorAll('.hidden-by-pagination:not(.hidden-by-filter)');
    let hiddenItemsArray=Array.from(hiddenItems);


    const loadMoreItemCount=6;

    const handler=()=>{

        for(let i=0;hiddenItemsArray.length && i<loadMoreItemCount; i++){
            const hiddenItem=hiddenItemsArray.shift();
            hiddenItem.classList.remove('hidden-by-pagination');
        }

        if(!hiddenItemsArray.length){
            loadMoreButton.style.display='none'
            loadMoreButton.removeEventListener('click', handler)
        }
    }

    if(hiddenItemsArray.length){
        loadMoreButton.style.display='block'
        loadMoreButton.addEventListener('click', handler)
    }else{
        loadMoreButton.style.display='none'
        loadMoreButton.removeEventListener('click', handler)
    }

}


